<template>
    <div class="story"></div>
</template>

<script>

export default {
  name: 'Story',
  data () {
    return {
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.story {
    background: url('./../assets/story.png') no-repeat center center fixed;
    background-size: cover;
    height: 100vh;
}

</style>



// WEBPACK FOOTER //
// src/components/Story.vue